export const controllerBundle = {
  all: { ko: "전체", en: "All", es: "Todo" }
}
